
import Vue, { RenderContext, CreateElement } from 'vue';

/**
 * Componente Panel.
 *
 * Sirve como container principal de las distintas secciones de una pagina.
 *
 * Puede comportarse como VLayout (row o column), como VFlex o usar cualquier otro tag.
 *
 * Por default usa tonalidades de gris (que varian segun si es dark o light) o puede ser white, reemplazando a VCard (usando page).
 */
export default Vue.extend({
    functional: true,
    render(h, ctx) {
        const cls = 'panel v-card v-card--flat' +
            (ctx.props.column ? ' column' : '') +
            (ctx.props.row ? ' row' : '') +
            (ctx.props.shadow ? ' shadow' : '') +
            (ctx.props.page ? ' page' : '') +
            (ctx.data.staticClass ? ' ' + ctx.data.staticClass : '')
            + ' ' + (Vue.prototype.$vuetify.dark ? 'theme--dark ' : 'theme--light ') + (ctx.props.color || '');

        return h(findTag(ctx), {...ctx.data, staticClass: cls}, ctx.children);
    },
    props: {
        /** Color de fondo del panel  */
        color: { type: String, required: false },
        /** Tag custom a utilizar (opcional) */
        tag: { type: String, required: false },
        /** Usar VLayout row como tag (los hijos iran uno al lado del otro) */
        row: Boolean,
        /** Usar VLayout column como tag (los hijos iran uno debajo del otro) */
        column: Boolean,
        /** Usar VFlex como tag */
        flex: Boolean,
        /** Agregar sombra, generando relieve (default false) */
        shadow: { type: Boolean, default: false },
        /** Usar fondo blanco en lugar de gris (o gris mas oscuro para modo dark) */
        page: { type: Boolean, default: false }
    }
});

function findTag(ctx: RenderContext<any>) {
    if (ctx.props.tag) return ctx.props.tag;
    if (ctx.props.row || ctx.props.column) return 'v-layout';
    if (ctx.props.flex) return 'v-flex';
    return 'div';
}
